import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    p: '16px 24px',
  },
  adminName: {
    fontSize: 16,
    fontWeight: '600',
    color: 'common.grey850',
    mb: '16px',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    py: '12px',
    borderBottom: '1px solid',
    borderColor: 'common.border',
  },
  name: {
    fontSize: 14,
    fontWeight: '500',
    color: 'grey.800',
  },
  email: {
    fontSize: 13,
    color: 'common.gray',
    wordBreak: 'break-all',
  },
  empty: {
    fontSize: 14,
    color: 'common.gray',
    py: '24px',
    textAlign: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
